// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__ZL_Rb","header":"ClearentDisclaimer_header__3MWq-","inner":"ClearentDisclaimer_inner__1J8vP"};